import { toast } from 'react-toastify';
// import { setReducerError } from '../redux/reducers/alertReducer';

// Custom Error Classes (similar to backend exceptions)
export class ApiError extends Error {
  constructor(message, status, originalError, errorData) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.originalError = originalError;
    this.errorData = errorData;
  }
}

export class ValidationError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 422, originalError, errorData);
    this.name = 'ValidationError';
  }
}

export class BadRequestError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 400, originalError, errorData);
    this.name = 'BadRequestError';
  }
}

export class AuthenticationError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 401, originalError, errorData);
    this.name = 'AuthenticationError';
  }
}

export class AuthorizationError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 403, originalError, errorData);
    this.name = 'AuthorizationError';
  }
}

export class NotFoundError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 404, originalError, errorData);
    this.name = 'NotFoundError';
  }
}

export class TimeoutError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 408, originalError, errorData);
    this.name = 'TimeoutError';
  }
}

export class ServerError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 500, originalError, errorData);
    this.name = 'ServerError';
  }
}

export class ConflictError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 409, originalError, errorData);
    this.name = 'ConflictError';
  }
}

export class BadGatewayError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 502, originalError, errorData);
    this.name = 'BadGatewayError';
  }
}

export class PreconditionFailedError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 412, originalError, errorData);
    this.name = 'PreconditionFailedError';
  }
}

export class RedirectError extends ApiError {
  constructor(message, errorData, originalError) {
    super(message, 302, originalError, errorData);
    this.name = 'RedirectError';
  }
}

const createCustomError = (status, message, errorData, originalError) => {
  switch (status) {
    case 302:
      return new RedirectError(message, errorData, originalError);
    case 400:
      return new BadRequestError(message, errorData, originalError);
    case 401:
      return new AuthenticationError(message, errorData, originalError);
    case 403:
      return new AuthorizationError(message, errorData, originalError);
    case 404:
      return new NotFoundError(message, errorData, originalError);
    case 408:
      return new TimeoutError(message, errorData, originalError);
    case 409:
      return new ConflictError(message, errorData, originalError);
    case 412:
      return new PreconditionFailedError(message, errorData, originalError);
    case 422:
      return new ValidationError(message, errorData, originalError);
    case 500:
    case 503:
      return new ServerError(message, errorData, originalError);
    case 502:
      return new BadGatewayError(message, errorData, originalError);
    default:
      return new ApiError(message, status, originalError, errorData);
  }
};

export const handleErrorException = (err, dispatch, reducerError, requestType, shouldThrow = false) => {
  const status = err?.response?.status;
  const errorData = err?.response?.data;

  const originalErrMsg = errorData?.detail?.[0]?.msg || errorData?.detail || 'An unexpected error occurred';

  let errMsg = originalErrMsg;
  console.log(requestType);

  if (requestType != 'get') {
    if (!errMsg) {
      switch (status) {
        case 400:
          errMsg = 'Bad Request - Please check your data';
          break;
        case 401:
          errMsg = 'Unauthorized - Please login again';
          break;
        case 403:
          errMsg = "Access Forbidden - You don't have permission to perform this action";
          break;
        case 404:
          errMsg = 'Resource not found';
          break;
        case 408:
          errMsg = 'Request Timeout - Please try again';
          break;
        case 409:
          errMsg = 'Conflict - Please try again';
          break;
        case 422:
          errMsg = 'Validation Error - Please check your input';
          break;
        case 500:
          errMsg = 'Internal Server Error - Please try again later';
          break;
        case 503:
          errMsg = 'Service Unavailable - Please try again later';
          break;
        default:
          errMsg = 'An unexpected error occurred';
      }
    }

    if (reducerError) {
      toast.error(errMsg);
    }

    if (reducerError) {
      dispatch(reducerError(errorData));
    }
  } else {
    dispatch(reducerError(errorData));
  }

  // Throw custom exception if requested
  if (shouldThrow) {
    const customError = createCustomError(status, errMsg, errorData, err);
    throw customError;
  }
};

// Alternative function that always throws exceptions
export const raiseErrorException = (err, dispatch, reducerError, requestType) => {
  return handleErrorException(err, dispatch, reducerError, requestType, true);
};
